module.exports = __webpack_public_path__ + "3_17_13_21_27/img/no-picture.9af7213.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/no-picture.jpg
// module id = CzZf
// module chunks = 1